import React from 'react';
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import  Sdata  from './Sdata';
import './Banner.css';

const Banner = () => {
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        appendDots: (dots) => {
            return <ul style={{ margin: "0px" }}>{dots}</ul>
        },
    }
    return (
        <>
            <Slider {...settings}>
                {Sdata.map((value, idx) => {
                    return (
                        <div key={idx + 1} >
                            <div className='box d_flex top'>
                                <div className='left'>
                                    <h1 className="text-2xl font-semibold text-gray-800 uppercase dark:text-white lg:text-3xl">{value.title}</h1>
                                    <p className="mt-2 text-gray-600 dark:text-gray-400">{value.desc}</p>
                                    <button className="w-1/2 tracking-wider px-6 py-2.5 mt-6 text-sm text-white uppercase transition-colors duration-300 transform bg-blue-600 rounded-md lg:w-auto hover:bg-blue-500 focus:outline-none focus:bg-blue-500">Shop Now</button>
                                </div>
                                <div className='right'>
                                    <img src={value.cover} alt='' />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
        </>
    );
};

export default Banner;